import {
    useDataGridSource,
} from 'app/PoC/DataGridDemoPages/components/hooks'
import requestConfig from 'app/requests/ServiceCenter/ServiceCenter.requests'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import SkyNetDataGrid from 'app/PoC/DataGridDemoPages/components/SkyNetDataGrid'
import useLabel from 'app/hooks/useLabel'

import useStyles from '../ServiceCentersDemoScenarioEditor.styles'
import columns from './InboundOrders.columns'

const InboundOrders = ({
    serviceCenterId,
}: Readonly<{ serviceCenterId: number }>) => {
    const l = useLabel()
    const {
        classes,
    } = useStyles()

    const dataSource = useDataGridSource({
        request: requestConfig.inboundOrders({
            serviceCenterId,
        }),
        key: RequestKeys.filterInboundOrders,
    })

    return (
        <SkyNetDataGrid
            persistentKey="demo-serviceCenterInboundOrders-table"
            columns={columns}
            customDataSource={dataSource}
            toolbarProps={{
                title: l('INBOUND_ORDERS'),
            }}
            classNames={{
                container: classes.tableContainer,
                tableWrapper: classes.tableWrapper,
            }}
        />
    )
}

export default InboundOrders
